import React, { useState } from 'react';
import { motion } from 'framer-motion';
import EsteticaModal from './EsteticaModal';

// Fondo fijo con imagen optimizada - Componente compartido
const FixedBackground = () => (
  <div className="fixed inset-0 -z-10 overflow-hidden">
    <div 
      className="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
        backgroundAttachment: 'scroll'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-crema/90 via-crema/95 to-crema/20"></div>
    </div>
    
    <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-b from-green-50/20 to-transparent hidden md:block"></div>
    <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-t from-teal-50/20 to-transparent hidden md:block"></div>

    <div className="absolute inset-0 opacity-3 md:opacity-5 mix-blend-overlay">
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <pattern 
          id="pattern" 
          x="0" 
          y="0" 
          width="60" 
          height="60" 
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(15)"
        >
          <circle cx="30" cy="30" r="1" fill="#869370" opacity="0.4" />
          <circle cx="45" cy="45" r="0.8" fill="#6a7556" opacity="0.3" />
        </pattern>
        <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern)" />
      </svg>
    </div>
    
    <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxkZWZzPjxmaWx0ZXIgaWQ9Im5vaXNlIj48ZmVUdXJidWxlbmNlIHR5cGU9ImZyYWN0YWxOb2lzZSIgYmFzZUZyZXF1ZW5jeT0iMC43IiBudW1PY3RhdmVzPSIzIiBzdGl0Y2hUaWxlcz0ic3RpdGNoIi8+PC9maWx0ZXI+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbHRlcj0idXJsKCNub2lzZSkiIG9wYWNpdHk9IjAuMDIiLz48L3N2Zz4=')] 
      mix-blend-overlay pointer-events-none opacity-50 md:opacity-100"></div>
  </div>
);

// Iconos con estilo verde
const DurationIcon = () => (
  <svg className="w-5 h-5 mr-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
  </svg>
);

const DressCodeIcon = () => (
  <svg className="w-5 h-5 mr-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
  </svg>
);

// Imágenes de tratamientos corporales
const treatmentImages = {
  lipolaser: 'https://agendapro.com/blog/wp-content/uploads/sites/2/2024/12/lipolaser-2-570x370-1.webp',
  electrodos: 'https://lh3.googleusercontent.com/proxy/dDYPQ9HbxFWeUeTlTL1KW29dql-b3hPE32QVbmS6keEMIuYyR_ya-N9mB66LVJb_-aSqB1EcRUycCpopTkwvqlHJI61VMlAPTebyOmu0Q6lR1VJM-fL1alOR6d5KwwE8Ii2tUQ',
  vacumterapia: 'https://novedadesesteticas.com/wp-content/uploads/2024/07/tratamientos-este%CC%81ticos-para-reducir-abdomen.webp',
  radiofrecuencia: 'https://draluisaguerra.com/wp-content/uploads/2021/04/Radio-Frecuencia-Corporal.jpg',
  maderoterapia: 'https://i.imgur.com/MdrMl8e.jpeg',
  maderoterapiaculeo: 'https://i0.wp.com/americanhealthandfitness.com.mx/wp-content/uploads/2022/03/maderoterapia-corporal-5.jpg?resize=474%2C317&ssl=1',
  drenaje: 'https://hotmart.s3.amazonaws.com/product_pictures/b0b7d918-36ed-44f1-8a0e-b6eb48a41f53/drenajelinfaticoprocedimiento2.jpg',
  liporeductor: 'https://cnclinics.de/wp-content/uploads/2019/03/cavitacion.jpg',
  diagnostico: 'https://cdn-3.expansion.mx/dims4/default/d7a58ae/2147483647/strip/true/crop/3996x2664+0+0/resize/1200x800!/format/webp/quality/60/?url=https%3A%2F%2Fcherry-brightspot.s3.amazonaws.com%2F6f%2Fd7%2F6c1fc6694754b875705d44a912fc%2Fshutterstock-50562769.jpg',
  electrodoss: 'https://cdn.movidasana.com/wp-content/uploads/2018/06/electrodos.webp',
  anticeluliticos: 'https://i.imgur.com/2dqFmak.png',
  peptonas: 'https://images.unsplash.com/photo-1512290900676-26c2a5a095ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
};

function EsteticaCorporales() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ 
    title: '', 
    description: '', 
    imageUrl: '', 
    duration: '', 
    dressCode: '', 
    benefits: [] 
  });

  const openModal = (title, description, imageKey, duration, dressCode, benefits) => {
    setModalContent({ 
      title: title || 'Tratamiento', 
      description: description || 'Descripción del tratamiento', 
      imageUrl: treatmentImages[imageKey] || treatmentImages.lipolaser || 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
      duration: duration || 'Consultar', 
      dressCode: dressCode || 'Ropa cómoda', 
      benefits: benefits || ['Beneficios del tratamiento'] 
    });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Tratamientos organizados fielmente según la lista de precios oficial de la imagen
  const tratamientosCorporales = [
    {
      category: "VALORACIÓN CORPORAL",
      subtitle: "Evaluación inicial personalizada para conocer tus necesidades",
      isPlus: false,
      items: [
        { 
          name: "Valoración inicial", 
          price: "Gs. 25.000", 
          subtitle: "10 a 15 minutos",
          description: "Evaluación profesional de tejido cutáneo, flacidez y distribución adiposa. *El valor de la valoración se descuenta del tratamiento al reservar.*", 
          imageKey: "diagnostico", 
          duration: "10/15 minutos", 
          dressCode: "Ropa cómoda", 
          benefits: ["Plan corporal 100% a medida", "Diagnóstico del grado de celulitis/flacidez", "El valor de Gs. 25.000 se descuenta al reservar"] 
        },
      ],
    },
    {
      category: "TRATAMIENTOS CORPORALES",
      subtitle: "Procedimientos de moldeo, reducción y tonificación",
      isPlus: false,
      items: [
        { 
          name: "Masaje reductor abdominal", 
          price: "Gs. 50.000", 
          subtitle: "",
          description: "Maniobras intensas y rítmicas aplicadas en el área abdominal para movilizar depósitos grasos, favorecer el drenaje y esculpir la figura.", 
          imageKey: "maderoterapia", 
          duration: "35 a 45 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Reduce medidas abdominales", "Estimula la circulación sanguínea", "Mejora el tono cutáneo"] 
        },
        { 
          name: "Maderoterapia adicional", 
          price: "Gs. 45.000", 
          subtitle: "",
          description: "Complemento especializado utilizando elementos de madera anatómicos para reafirmar y moldear contornos específicos del cuerpo.", 
          imageKey: "maderoterapia", 
          duration: "25 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Reafirma y moldea tejidos", "Estimula la producción de elastina", "Complemento ideal para masajes"] 
        },
        { 
          name: "Mascarilla abdominal adicional", 
          price: "Gs. 30.000",
          subtitle: "",
          description: "Aplicación de mascarilla concentrada en principios activos reafirmantes y desintoxicantes para enriquecer la piel abdominal.", 
          imageKey: "anticeluliticos", 
          duration: "20 minutos", 
          dressCode: "Ropa cómoda", 
          benefits: ["Nutrición y firmeza para la piel", "Potencia el efecto reductor", "Suaviza la textura abdominal"] 
        },
        { 
          name: "Reductor + marcaje de cintura", 
          price: "Gs. 80.000", 
          subtitle: "",
          description: "Tratamiento combinado enfocado en la cintura y flancos para acentuar las curvas y definir una silueta estilizada.", 
          imageKey: "vacumterapia", 
          duration: "45 a 60 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Define la curvatura de la cintura", "Reduce grasa en los laterales", "Esculpe la silueta"] 
        },
        { 
          name: "Drenaje linfático brasilero", 
          price: "Gs. 180.000", 
          subtitle: "",
          description: "Técnica brasileña exclusiva de pases suaves que estimulan el sistema linfático, combatiendo la retención de líquidos y modelando el cuerpo de forma inmediata.", 
          imageKey: "drenaje", 
          duration: "60 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Eliminación inmediata de líquidos retenidos", "Desintoxicación del organismo", "Sensación de ligereza total"] 
        },
        { 
          name: "Lipoláser", 
          price: "Gs. 50.000", 
          subtitle: "por sesión",
          description: "Tecnología láser diodo no invasiva que disuelve los adipocitos y reduce volumen corporal sin dolor ni periodo de reposo.", 
          imageKey: "lipolaser", 
          duration: "40 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Disuelve adiposidad localizada", "No produce dolor ni hematomas", "Resultados progresivos"] 
        },
        { 
          name: "Radiofrecuencia", 
          price: "Gs. 40.000", 
          subtitle: "",
          description: "Emisión de ondas electromagnéticas que calientan las capas profundas de la piel para activar colágeno y combatir la flacidez.", 
          imageKey: "radiofrecuencia", 
          duration: "30 a 40 minutos", 
          dressCode: "Ropa cómoda", 
          benefits: ["Reafirma pieles flácidas", "Estimula el colágeno natural", "Mejora la elasticidad"] 
        },
        { 
          name: "Electroporador", 
          price: "Gs. 60.000", 
          subtitle: "",
          description: "Apertura temporal de microporos mediante impulsos electromagnéticos para la penetración profunda de principios activos reafirmantes o lipolíticos.", 
          imageKey: "electrodos", 
          duration: "30 minutos", 
          dressCode: "Ropa cómoda", 
          benefits: ["Mayor penetración de productos", "Tratamiento sin agujas", "Potencia la respuesta celular"] 
        },
        { 
          name: "Electrodos", 
          price: "Gs. 40.000", 
          subtitle: "por zona",
          description: "Electroestimulación neuromuscular que fortalece, tonifica y define los músculos en áreas focalizadas.", 
          imageKey: "electrodoss", 
          duration: "35 a 45 minutos", 
          dressCode: "Ropa deportiva / cómoda", 
          benefits: ["Tonificación muscular intensa", "Mejora la firmeza", "Equivale a entrenamiento localizado"] 
        },
        { 
          name: "Ultracavitación", 
          price: "Gs. 40.000", 
          subtitle: "",
          description: "Ultrasonido de baja frecuencia que genera microburbujas para romper células grasas rebeldes y facilitar su expulsión natural.", 
          imageKey: "liporeductor", 
          duration: "30 a 40 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Rompe adiposidad dura", "Modela zonas difíciles", "Tratamiento no invasivo"] 
        },
        { 
          name: "Anticelulítico", 
          price: "Gs. 60.000", 
          subtitle: "por zona",
          description: "Tratamiento especializado mediante masajes y técnicas activas para alisar la superficie cutánea y reducir la apariencia de piel de naranja.", 
          imageKey: "anticeluliticos", 
          duration: "40 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Alisa la textura cutánea", "Activa la microcirculación", "Reduce nódulos celulíticos"] 
        },
        { 
          name: "Maderoterapia para celulitis", 
          price: "Gs. 40.000", 
          subtitle: "por zona",
          description: "Uso de copas suecas y rodillos de madera para drenar depósitos de celulitis y devolverle la firmeza a la piel.", 
          imageKey: "maderoterapiaculeo", 
          duration: "30 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Drena toxinas y celulitis", "Estimula el flujo linfático", "Técnica corporal natural"] 
        },
        { 
          name: "Levantamiento de glúteos con madero + masajes", 
          price: "Gs. 80.000", 
          subtitle: "",
          description: "Combinación de maderoterapia técnica y masajes moldeadores para realzar, reposicionar y tonificar la zona glútea.", 
          imageKey: "maderoterapiaculeo", 
          duration: "45 a 50 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Efecto push-up en glúteos", "Tonifica y reafirma", "Mejora el contorno muscular"] 
        },
      ],
    },
    {
      category: "TRATAMIENTOS PLUS CORPORAL",
      subtitle: "Técnicas avanzadas con activos de alto rendimiento",
      isPlus: true,
      items: [
        { 
          name: "Peptonas en glúteos + Dermapen", 
          price: "Gs. 255.000", 
          subtitle: "",
          description: "Terapia biológica de péptidos concentrados aplicada con microagujas para estimular la síntesis proteica, aumentando volumen y firmeza en los glúteos.", 
          imageKey: "liporeductor", 
          duration: "60 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Incrementa la firmeza y volumen", "Nutrición biológica muscular", "Resultados de larga duración"] 
        },
        { 
          name: "Fosfatidilcolina", 
          price: "Gs. 150.000", 
          subtitle: "por zona",
          description: "Aplicación de activo lipolítico de máxima eficacia que disuelve la membrana del adipocito para eliminar acumulaciones adiposas localizadas.", 
          imageKey: "liporeductor", 
          duration: "30 a 40 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Disolución eficaz de grasa rebelde", "Ideal para abdomen o cintura", "Reducción evidente de medidas"] 
        },
        { 
          name: "Tensores", 
          price: "desde Gs. 120.000", 
          subtitle: "por zona",
          description: "Procedimiento reafirmante con activos tensores para restructurar la dermis y solucionar problemas de flacidez severa.", 
          imageKey: "radiofrecuencia", 
          duration: "45 minutos", 
          dressCode: "Ropa cómoda", 
          benefits: ["Efecto tensor inmediato", "Reestructura tejidos flácidos", "Combate la laxitud cutánea"] 
        },
        { 
          name: "Anticelulítico", 
          price: "Gs. 120.000", 
          subtitle: "por zona",
          description: "Protocolo Plus de grado profesional con sinergia de activos concentrados y aparatología para tratar grados avanzados de celulitis.", 
          imageKey: "anticeluliticos", 
          duration: "50 a 60 minutos", 
          dressCode: "Ropa interior cómoda", 
          benefits: ["Acción profunda contra la celulitis", "Mejora radical de la elasticidad", "Descongestiona el tejido"] 
        },
      ],
    },
  ];

  return (
    <div className="relative">
      <div className="relative z-10">
        <FixedBackground />
        <motion.section 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="min-h-screen relative overflow-hidden py-20 pt-32"
        >
          {/* Elementos decorativos verdes */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none">
            <div className="absolute top-20 left-10 w-40 h-40 bg-green-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob"></div>
            <div className="absolute top-1/3 right-20 w-48 h-48 bg-teal-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000"></div>
            <div className="absolute bottom-20 left-1/3 w-52 h-52 bg-emerald-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-4000"></div>
          </div>

          <div className="container mx-auto px-4 relative z-10">
            {/* Header decorativo idéntico al flyer */}
            <motion.div
              initial={{ y: -20 }}
              animate={{ y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-center mb-16"
            >
              <div className="inline-block px-4 py-1.5 rounded-full bg-green-100/80 text-green-800 text-sm font-medium mb-3 shadow-sm border border-green-200">
                Tu cuerpo también merece cuidado ♡
              </div>
              
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-green-700 mb-4 font-serif">
                Tratamientos Corporales
              </h2>
              <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto font-light leading-relaxed">
                Descubrí nuestras técnicas estéticas diseñadas para acompañar tus objetivos corporales, trabajando el moldeado, la tonificación y el bienestar corporal.
              </p>
              
              <div className="mt-6 flex justify-center">
                <div className="w-32 h-1 bg-gradient-to-r from-green-400 via-teal-400 to-emerald-400 rounded-full"></div>
              </div>
            </motion.div>

            {/* Renderizado de categorías */}
            <div className="space-y-16">
              {tratamientosCorporales.map((categoryData, catIdx) => (
                <div key={catIdx} className="space-y-8">
                  {/* Encabezado de categoría tipo Banner de la imagen */}
                  <div className={`p-6 rounded-2xl shadow-sm backdrop-blur-md border ${
                    categoryData.isPlus 
                      ? 'bg-gradient-to-r from-emerald-900/90 to-teal-800/90 text-white border-emerald-700/50' 
                      : 'bg-white/70 text-gray-800 border-green-200/60'
                  }`}>
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
                      <div className="flex items-center space-x-3">
                        <span className={`p-2.5 rounded-xl ${categoryData.isPlus ? 'bg-white/20 text-emerald-200' : 'bg-green-100 text-green-700'}`}>
                          <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M5 21v-4M3 19h4m10-16v4m2-2h-4m4 14v-4m2 2h-4M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </span>
                        <div>
                          <h3 className={`text-2xl md:text-3xl font-bold font-serif ${categoryData.isPlus ? 'text-white' : 'text-green-900'}`}>
                            {categoryData.category}
                          </h3>
                          <p className={`text-sm ${categoryData.isPlus ? 'text-emerald-100' : 'text-gray-600'}`}>
                            {categoryData.subtitle}
                          </p>
                        </div>
                      </div>
                      {categoryData.isPlus && (
                        <span className="self-start md:self-auto bg-amber-400 text-gray-900 text-xs font-bold uppercase px-3 py-1 rounded-full shadow-sm">
                          Protocolos Exclusivos
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Grid de servicios de la categoría */}
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {categoryData.items.map((item, itemIndex) => (
                      <motion.div
                        key={itemIndex}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: itemIndex * 0.05, duration: 0.4 }}
                        whileHover={{ y: -6, transition: { duration: 0.2 } }}
                        className="bg-white/60 backdrop-blur-md rounded-2xl shadow-md border border-white/60 overflow-hidden hover:shadow-xl hover:bg-white/80 transition-all flex flex-col justify-between group"
                      >
                        <div className="p-6">
                          <div className="flex justify-between items-start mb-3 gap-2">
                            <h4 className="text-lg font-bold text-gray-800 group-hover:text-green-700 transition-colors leading-snug">
                              {item.name}
                            </h4>
                            <div className="text-right flex-shrink-0">
                              <span className="inline-block bg-gradient-to-r from-green-700 to-emerald-600 text-white font-bold px-3 py-1 rounded-full text-sm shadow-sm whitespace-nowrap">
                                {item.price}
                              </span>
                              {item.subtitle && (
                                <span className="block text-[11px] text-gray-500 font-medium mt-0.5">
                                  {item.subtitle}
                                </span>
                              )}
                            </div>
                          </div>

                          <p className="text-gray-600 text-sm line-clamp-3 mb-4 leading-relaxed">
                            {item.description}
                          </p>
                        </div>

                        <div className="px-6 pb-6 pt-0">
                          <button
                            onClick={() => openModal(item.name, item.description, item.imageKey, item.duration, item.dressCode, item.benefits)}
                            className="w-full py-2.5 px-4 bg-green-50 hover:bg-green-600 text-green-700 hover:text-white rounded-xl text-sm font-semibold transition-all duration-300 flex items-center justify-center space-x-2 border border-green-200/60 shadow-sm"
                          >
                            <span>Ver detalles del tratamiento</span>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                            </svg>
                          </button>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Pie de página decorativo idéntico a la imagen */}
            <div className="mt-20 text-center">
              <div className="inline-flex items-center justify-center px-6 py-2 rounded-full bg-white/80 shadow-md border border-green-200 space-x-2">
                <span className="text-green-700 font-serif italic text-lg font-semibold">Cuidá de vos ♡</span>
              </div>
              <p className="text-sm text-gray-500 mt-3 font-medium uppercase tracking-widest">
                CLEO ESTÉTICA • FACIAL Y CORPORAL
              </p>
            </div>
          </div>
        </motion.section>

        <EsteticaModal
          isOpen={isModalOpen}
          onClose={closeModal}
          title={modalContent.title}
          content={modalContent.description}
          imageUrl={modalContent.imageUrl}
          duration={modalContent.duration}
          dressCode={modalContent.dressCode}
          benefits={modalContent.benefits}
          DurationIcon={DurationIcon}
          DressCodeIcon={DressCodeIcon}
        />

        {/* Animaciones */}
        <style jsx>{`
          @keyframes blob {
            0% {
              transform: translate(0px, 0px) scale(1);
            }
            33% {
              transform: translate(30px, -50px) scale(1.1);
            }
            66% {
              transform: translate(-20px, 20px) scale(0.9);
            }
            100% {
              transform: translate(0px, 0px) scale(1);
            }
          }
          .animate-blob {
            animation: blob 7s infinite;
          }
          .animation-delay-2000 {
            animation-delay: 2s;
          }
          .animation-delay-4000 {
            animation-delay: 4s;
          }
        `}</style>
      </div>
    </div>
  );
}

export default EsteticaCorporales;